export default "__VITE_ASSET__dn7o9Gbu__"